import { Injectable, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Vendor } from '../../../model/Vendor';
import { GenericResponse } from '../../../model/genericResponse';
import { NgbModal } from '@otas/modal/modal';



@Injectable()
export class VenderService {

  constructor(public modalService: NgbModal, private http: HttpClient) { }
  openVendorAddModal(component: Component, heading, data) {
    const modalRef = this.modalService.open(component);
    modalRef.componentInstance.heading = heading;
    modalRef.componentInstance.data = data;
    return modalRef;
  }

  getAllVendors(): Observable<GenericResponse<Vendor[]>> {
    return this.http.get<GenericResponse<Vendor[]>>(`temple/vendor_customer`);
  }
  saveVendor(Vendors): Observable<GenericResponse<Vendor>> {
    if (!!Vendors.id) {
      return this.http.post<GenericResponse<Vendor>>('temple/vendor_customer', Vendors);
    }
    return this.http.post<GenericResponse<Vendor>>('temple/vendor_customer', Vendors);
  }
  editOldVendor(Vendors): Observable<GenericResponse<Vendor>> {
    return this.http.put<GenericResponse<Vendor>>('temple/vendor_customer', Vendors);
  }
  deleteOldVendor(Vendors): Observable<GenericResponse<Vendor>> {
    return this.http.delete<GenericResponse<Vendor>>('temple/vendor_customer');
  }
}
